// Module I/O interchange
import Carousel from './Carousel';
import Video from './Video';
import Toggle from './Toggle';
import Timeline from './Timeline';
import LiveRoles from './LiveRoles';
import CustomFileInput from './CustomFileInput';
import JobPortal from './JobPortal';
import CustomSelect from './CustomSelect';
import ReferralCode from './ReferralCode';
import StickyElement from './StickyElement';
import ScrollToAnchor from './ScrollToAnchor';
import CountrySelector from './CountrySelector';
import Modal from './Modal';
import Truncate from './Truncate';
import Shop from './Shop';
import MerchantFormSubmission from './MerchantSubmission';
import InvoiceDownload from './InvoiceDownload';
import AdvanceCalculator from './AdvanceCalculator';
import InView from './InView';
import Collapsible from './Collapsible';
import Transcript from './Transcript';
import LottieAnimation from './LottieAnimation';
import PricingCalculatorPage from './PricingCalculatorPage';

export default {
  Carousel,
  Toggle,
  Video,
  Timeline,
  LiveRoles,
  CustomFileInput,
  JobPortal,
  CustomSelect,
  ReferralCode,
  StickyElement,
  ScrollToAnchor,
  CountrySelector,
  Modal,
  Truncate,
  Shop,
  MerchantFormSubmission,
  InvoiceDownload,
  AdvanceCalculator,
  InView,
  Collapsible,
  Transcript,
  LottieAnimation,
  PricingCalculatorPage
}



// WEBPACK FOOTER //
// ./js/modules/index.js